import React from "react";

const merge = (ranges) => {
  var result = [],
    last;

  ranges.forEach(function (r) {
    if (!last || r[0] > last[1]) result.push((last = r));
    else if (r[1] > last[1]) last[1] = r[1];
  });

  return result;
};

const TextHighlight = (props) => {
  const highlight = props.highlight === undefined ? [] : props.highlight;
  const text = props.text === undefined ? "" : props.text;
  const textTarget = props.textTarget === undefined ? "" : props.textTarget;
  const tmMatchWords =
    props.matchTmTarget === undefined ? "" : props.matchTmTarget;

  let coors = [];

  //Find start/end locations of each substring
  /*highlight.forEach((word) => {
    if (!word) return;
    let position = text.toLowerCase().search(word.toLowerCase());
    if (position !== -1) coors.push([position, position + word.length - 1]);
  });*/

  const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  highlight.forEach((word) => {
    if (!word) return;

    const w = word.trim();
    if (!w) return;

    // \b means “word boundary” (between [A-Za-z0-9_] and non-word chars)
    const re = new RegExp(`\\b${escapeRegExp(w)}\\b`, "gi");

    let m;
    while ((m = re.exec(text)) !== null) {
      coors.push([m.index, m.index + m[0].length - 1]);

      // safety against zero-length matches (rare here, but good practice)
      if (m.index === re.lastIndex) re.lastIndex++;
    }
  });

  //Sort and merge overlapping ranges
  coors.sort((a, b) => a[0] - b[0] || a[1] - b[1]);
  coors = merge(coors);

  let JSX = [];

  for (let i = 0; i < text.length; i++) {
    const char = text.charAt(i);

    const found = coors.some((coor) => {
      if (i == coor[0]) {
        //Beginning
        JSX.push(
          <span className={"highlight " + props.className}>
            {text.substring(coor[0], coor[1] + 1)}
          </span>
        );
        i = coor[1];
        return true;
      }
      return false;
    });

    if (!found) JSX.push(char);
  }
  return JSX;
};
export default React.memo(TextHighlight, (prevProps, nextProps) => {
  return (
    prevProps.highlight == nextProps.highlight &&
    prevProps.text == nextProps.text
  );
});
